import React, { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  getLFDiagnosticTest,
  saveLFDiagnosticTest,
} from "../../../../api/liftOffDiagnosticTest.service";
import { ILiftOffDiagnosticTest } from "../../../../model/interface/liftOffDiagnosticTest";
import { ILiftOffHeader } from "../../../../model/interface/subject";
import Loader from "../../../shared/loader/loader";
import StandardCardProps from "./standardCard";

interface StandardHierarchyTabProps extends ILiftOffHeader {
  num?: number;
}

const StandardHierarchyTab = (props: StandardHierarchyTabProps) => {
  const [selectedTestId, setSelectedTestId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [lfDiagTest, setLFDiagTest] = useState<Array<ILiftOffDiagnosticTest>>(
    []
  );
  const [isReload, setIsReload] = useState<boolean>(false);

  useEffect(() => {
    getData();
  }, [props.liftOffHeaderId, isReload]);

  const getData = (testId = 0) => {
    setLoading(true);
    getLFDiagnosticTest(props.liftOffHeaderId, props.subjectId)
      .then((r) => {
        setLoading(false);
        setLFDiagTest([]);
        setLFDiagTest(r.data);
        if (testId > 0) {
          setSelectedTestId(testId);
        } else if (r.data && r.data.length > 0) {
          setSelectedTestId(r.data[0].liftOffDiagnosticTestId);
        }
      })
      .catch((r) => {
        setLoading(false);
      });
  };

  const handleAddNewTest = () => {
    const defaultTest: ILiftOffDiagnosticTest = {
      liftOffDiagnosticTestId: 0,
      name: props.header,
      liftOffHeaderId: props.liftOffHeaderId,
      subjectId: props.subjectId,
      isActive: true,
      createdByUserId: 0,
    };

    setLFDiagTest((prev) => {
      return [...prev, defaultTest];
    });
  };

  const handleStandardCardSelection = (lfDiagTestId: number) => {
    setSelectedTestId(lfDiagTestId);
  };

  const handleSaveTest = (data: any) => {
    setLoading(true);
    saveLFDiagnosticTest(data.test, data.questions)
      .then((r) => {
        getData(r.data);
        setLoading(false);
        toast.success("Successfully saved.");
      })
      .catch((r) => {
        setLoading(false);
        toast.success("Something went wrong.");
      });
  };

  return (
    <Fragment>
      {loading && <Loader />}
      {lfDiagTest.map((item, index) => {
        return (
          <Fragment key={index}>
            <StandardCardProps
              {...item}
              isStandardCardSelected={
                item.liftOffDiagnosticTestId === selectedTestId
              }
              key={index}
              onClicked={(lfDiagTestId) => {
                handleStandardCardSelection(lfDiagTestId);
              }}
              saveTest={handleSaveTest}
              setIsReload={setIsReload}
              isReload={isReload}
            />
          </Fragment>
        );
      })}
      <div className="flex justify-end">
        <button
          type="submit"
          className="inline-flex items-center px-3 py-2 mt-4 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
          onClick={() => {
            handleAddNewTest();
          }}
        >
          Add New Test
        </button>
      </div>
    </Fragment>
  );
};

export default StandardHierarchyTab;
